import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSaq: CultureInfo = {
  name: 'saq',
  displayName: 'Kisampur',
  iso3LanguageCode: 'saq',
  iso2LanguageCode: 'saq',
  ietfLanguageTag: 'saq',
  parent: null
};
